<template>
  <footer id="footer" class="col-12">
    <div class="col-12 row">
      <div class="col-sm-5 text-center">
        <router-link to="/" id="logo_url">
          <img :src="logo" :alt="alt" id="logo" class="img-fluid" />
        </router-link>
      </div>
      <div class="col-sm-2">
        
      </div>
      <div class="col-sm-5 text-center">
        <p class="pt-3">
          <social btn="dark" />
        </p>
      </div>
    </div>
    <div class="col-12 text-center pb-1">
      <small>
        <p>&copy;2025 Saia do sofá - Todos os direitos reservado. <br>
          Desenvolvido por <a class="btn btn-sm btn-dark" target="_blank" href="https://wmatech.com.br">WMATECH</a> </p>
      </small>
    </div>
  </footer>
</template>

<script>
import Menu from './Menu.vue';
import Social from "./Social.vue";

export default {
  components: { Social, Menu },
  name: "Footer",
  props: ["logo", "alt"],
};
</script>

<style scoped>
#footer {
  background-color: var(--cor-fundo-base);
  border-top: 4px solid #111;
  color: var(--cor-base-texto);
  /* display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; */
}

small {
  font-size: 12px;
}
</style>